/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useHeaderLayoutStyles = makeStyles<Theme, { drawerWidth: number }>((theme: Theme) =>
  createStyles({
    appBar: {
      backgroundColor: '#FFFFFF',
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      borderBottom: `1px solid #EEEEEE`,

      borderLeft: `none`,
      boxShadow: `unset !important`,
    },
    appBarShift: {
      width: ({ drawerWidth }) => `calc(100% - ${drawerWidth}px)`,
      marginLeft: ({ drawerWidth }) => drawerWidth,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    toolbarRegular: {
      minHeight: '76px',
    },
    toolbarGutters: {
      paddingLeft: '40px',
      paddingRight: '40px',
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    hide: {
      display: 'none',
    },
    createButtonContainer: {
      alignSelf: 'center',
      marginRight: '6px',
    },
    sectionDesktop: {
      display: 'flex',
      marginLeft: 'auto',
    },
  }),
);
